import React from "react";

//Material-UI Core Components
import Box from '@mui/material/Box';
import Container from "@mui/material/Container";

//Custom Components
import PublicPage from "UI/PublicPage/PublicPage";
import LoginForm from "Views/Auth/LoginForm";

import model from "Models/user";
import dataController from "Lib/dataController";

function LoginPage() {

  const dc = new dataController(model)

  return (
    <PublicPage>
      <Box m={2}>
        <Container maxWidth={"sm"}>
          <LoginForm dc={dc} form="login" mode="update" onClose={() => {}} />
        </Container>
      </Box>
    </PublicPage>
  )
}

export default LoginPage;
